export default "__VITE_ASSET__2450013a__"